define.alias("shared/components/shared/wizard/slide/body", "preview-grid/components/shared/wizard/slide/body");